<template>
    <div class="sa-utility-page-wrapper">
        <div class="sa-utility-header">
            <div style="flex: 1">
                <h2 class="h4 mb-1 font-weight-bold">{{ jsonData.nomeArticolo }}</h2>
                <small class="sa-articolo-text-muted">
                    Codice Interno: <strong>{{ jsonData.codiceArticolo }}</strong>
                </small>
                <small class="sa-articolo-text-muted">
                    Codice Barre: <strong>{{ jsonData.codiceArticolo }}</strong>
                </small>
            </div>
            <div style="flex: 1">
                <div class="sa-articolo-barcode-container text-right">
                    <span class="sa-utility-label">Codice a Barre (EAN/CODE128)</span>
                    <svg ref="barcodeCanvas"></svg>
                </div>
            </div>
        </div>
        <b-row class="mt-4">
            <b-col lg="8">
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12" class="mb-3">
                        <span class="sa-utility-label">Descrizione Estesa</span>
                        <p class="sa-utility-value">
                            {{ jsonData.descrizioneArticolo }}
                        </p>
                    </b-col>
                    <b-col xs="12" sm="5" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Codice Azienda</span>
                        <span class="sa-utility-value">{{ jsonData.codiceAzienda }}</span>
                    </b-col>
                    <b-col xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Tipo</span>
                        <span class="sa-utility-value">{{ jsonData.descrizioneTipoArticolo }}</span>
                    </b-col>
                    <b-col xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Codice AIC</span>
                        <span class="sa-utility-value">{{ jsonData.codiceAic || "---" }}</span>
                    </b-col>
                    <b-col xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Unità di Misura</span>
                        <b-badge variant="info">{{ jsonData.descrizioneMultiplo }}</b-badge>
                    </b-col>
                    <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                        <span class="sa-utility-label">Unità di Misura Base:</span>
                        <b-badge variant="light">{{ jsonData.descrizioneMultiploBase }}</b-badge>
                    </b-col>
                    <b-col xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Categoria</span>
                        <span class="sa-utility-value">{{ jsonData.categoria }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Marca</span>
                        <span class="sa-utility-value">{{ jsonData.marca }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Imballo</span>
                        <span class="sa-utility-value">{{ jsonData.descrizioneImballo }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">I.V.A.</span>
                        <span class="sa-utility-value">{{ jsonData.descrizioneIva }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Colli</span>
                        <span class="sa-utility-value">{{ jsonData.colliArticolo }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Peso(kg):</span>
                        <span>{{ formatFloat(jsonData.pesoArticolo, 2) }}</span>
                    </b-col>

                    <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Lunghezza (cm)</span>
                        <span>{{ formatFloat(jsonData.lunghezzaArticolo, 2) }}</span>
                    </b-col>

                    <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Altezza(cm)</span>
                        <span>{{ formatFloat(jsonData.altezzaArticolo, 2) }}</span>
                    </b-col>

                    <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4" class="mb-3">
                        <span class="sa-utility-label">Larghezza(cm):</span>
                        <span>{{ formatFloat(jsonData.larghezzaArticolo, 2) }}</span>
                    </b-col>
                </b-row>
            </b-col>

            <b-col lg="4">
                <div class="sa-articolo-box-prezzo mb-3">
                    <b-row>
                        <b-col cols="6" class="mb-2">
                            <span class="sa-utility-label text-primary">Ultimo Prezzo Acq.</span>
                            <span class="h5 font-weight-bold">{{ jsonData.ultimoPrezzoAcquisto ? "€ " +
                                jsonData.ultimoPrezzoAcquisto : "€ ---" }}</span>
                        </b-col>
                        <b-col cols="6" class="mb-2">
                            <span class="sa-utility-label text-primary">Prezzo Medio Acq.</span>
                            <span class="h5 font-weight-bold">{{ jsonData.prezzoMedioAcquisto ? "€ " +
                                jsonData.prezzoMedioAcquisto : "€ ---" }}</span>
                        </b-col>
                        <b-col cols="6">
                            <span class="sa-utility-label">Sconto</span>
                            <span class="sa-utility-value">{{ jsonData.scontoArticolo }} %</span>
                        </b-col>
                        <b-col cols="6">
                            <span class="sa-utility-label">Sottoscorta</span>
                            <span class="sa-utility-value text-danger">{{ jsonData.sottoscortaArticolo || "-" }}</span>
                        </b-col>
                        <b-col cols="12">
                            <span class="sa-utility-label">Giacenza Attuale</span>
                            <span class="sa-utility-value text-danger">{{ jsonData.giacenze || "-" }}</span>
                        </b-col>
                    </b-row>
                </div>
                <div class="sa-articolo-box-prezzo mb-3">
                    <b-list-group flush>
                        <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                            Gestione Lotti <b-badge :variant="jsonData.gestioneLottiScadenze ? 'success' : 'light'">{{
                                jsonData.gestioneLottiScadenze ? "SÌ" : "NO" }}</b-badge>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                            Matricole <b-badge :variant="jsonData.gestioneMatricole ? 'success' : 'light'">{{
                                jsonData.gestioneMatricole ? "SÌ" : "NO" }}</b-badge>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </b-col>
        </b-row>
        <div class="sa-articolo-footer">
            <span class="sa-utility-label"><i class="far fa-comment-dots mr-1"></i> Note Articolo</span>
            <p class="small text-muted mb-0">{{ jsonData.noteArticolo || "Nessuna nota aggiuntiva per questo presidio."
                }}</p>
        </div>
        <modal-error ref="cmpModalError" />
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import MagazzinoMixins from "../mixins/MagazzinoMixins";
import JsBarcode from "jsbarcode";
export default {
    name: "MagazzinoArticoliAnagraficaEditComponent",
    mixins: [UtilityMixin, MagazzinoMixins],
    components: { ModalError },
    data() {
        return {
            id: "-1",
            pathResourceMagazzinoArticolo: "/magazzinoarticoli",
            jsonData: {
                id: null,
                codiceTipoArticolo: null,
                codiceArticolo: null,
                codiceBarre: null,
                nomeArticolo: null,
                descrizioneArticolo: null,
                codiceAzienda: null,
                um: null,
                categoria: null,
                marca: null,
                descrizioneMultiplo: null,
                descrizioneImballo: null,
                codiceIva: null,
                gestioneLottiScadenze: null,
                gestioneMatricole: null,
                ultimoPrezzoAcquisto: null,
                prezzoMedioAcquisto: null,
                scontoArticolo: null,
                sottoscortaArticolo: null,
                prezzoAcquistoStandard: null,
                colliArticolo: null,
                pesoArticolo: null,
                lunghezzaArticolo: null,
                altezzaArticolo: null,
                larghezzaArticolo: null,
                noteArticolo: null,
                giacenze: null,
                codiceAic: null,
            },
        };
    },
    computed: {
        gestioneLottiScadenzeText() {
            let me = this;
            if (me.jsonData.gestioneLottiScadenze === null) return "-";
            return me.jsonData.gestioneLottiScadenze ? "Sì" : "No";
        },
        gestioneMatricoleText() {
            let me = this;
            if (me.jsonData.gestioneMatricole === null) return "-";
            return me.jsonData.gestioneMatricole ? "Sì" : "No";
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        this.mangazzinoArticoliUnitaMisuraLoadData();
        if (me.id != -1) {
            console.log("Entro nel if del mounted per visualizzazione");
            console.log("ID: ", me.id);
            me.loadDataArticoloMagazzino(me.id);
        }
    },
    beforeDestroy() {
        let me = this;
        me.controlEmit = false;
    },
    watch: {
        "jsonData.codiceTipoArticolo"(newValue) {
            let me = this;
            me.$emit("tipoArticolo", newValue);
        },
    },
    methods: {
        loadDataArticoloMagazzino(id) {
            let me = this;
            me.$emit("beforeLoadData");
            UtilityMixin.methods.loadDataResources(me.pathResourceMagazzinoArticolo + "/" + id, null, me.loadDataArticoloMagazzinoSuccess, me.loadDataArticoloMagazzinoError);
        },

        loadDataArticoloMagazzinoSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.jsonData = response.data.data;
            me.generaNuovoBarcode();
            me.$emit("updateJsonData", me.jsonData);
        },

        loadDataArticoloMagazzinoError(response) {
            let me = this;
            me.$emit("afterLoadData");
            console.log(response);
            me.$refs.cmpModalError.show("Errore durante il caricamento dei dati dell'articolo");
        },
        generaNuovoBarcode() {
            if (this.jsonData.codiceBarre !== null && this.jsonData.codiceBarre !== "") {
                JsBarcode(this.$refs.barcodeCanvas, this.jsonData.codiceBarre, {
                    format: "CODE128",
                    lineColor: "#000",
                    width: 2,
                    height: 30,
                    displayValue: true,
                });
            }
        },
    },
};
</script>

<style>
/* Personalizzazione con prefisso sa-articolo */

.sa-articolo-card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.sa-articolo-nav .nav-link {
    color: #6c757d;
    border: none;
    border-bottom: 2px solid transparent;
    font-weight: 500;
}

.sa-articolo-nav .nav-link.active {
    color: #007bff !important;
    border-bottom: 2px solid #007bff;
    background: transparent !important;
}

.sa-articolo-header {
    border-left: 3px solid var(--bg-sidebar);
    padding: 10px;
    margin-bottom: 25px;
    background-color: var(--bg-main-container);
    border-radius: 5px;
    display: flex;
    flex-direction: row;
}

.sa-articolo-label {
    font-size: 0.95rem;
    text-transform: uppercase;
    color: #adb5bd;
    font-weight: 700;
    display: block;
    margin-bottom: 2px;
}

.sa-articolo-value {
    font-size: 1rem;
    color: #343a40;
    font-weight: 500;
    word-break: break-all;
}

.sa-articolo-box-prezzo {
    background-color: var(--bg-main-container);
    padding: 15px;
    border-radius: 8px;
    border-left: 3px solid var(--bg-sidebar);
}

.sa-articolo-footer {
    border-top: 1px solid #dee2e6;
    margin-top: 30px;
    padding-top: 20px;
}

.sa-articolo-text-muted {
    font-size: 0.95rem;
}

.sa-articolo-box-prezzo .list-group-item {
    background-color: transparent !important;
}
</style>
